import { Injectable } from '@angular/core';
import { WebObjectModel } from '../Models/web-object-model';
import { WebobjectMock } from '../DataStore/Mock/webobject-mock';
import { PageModel } from '../Models/page-model';
import { RestService } from './rest.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WebobjectServiceService {
  constructor(public rest: RestService) { }
  public findByObjectId(id: string): WebObjectModel {
    return WebobjectMock.findByObjectId(id);
  }
  public getObjects(webpage_id): Observable<WebObjectModel[]> {
    return this.rest.get('webpagewebobject', webpage_id);
  }
  public getObjectsdb2(webpage_id): Observable<WebObjectModel[]> {
    return this.rest.get('webpagewebobjectdb2', webpage_id);
  }
  public getObjectsByPageObject(model: PageModel): WebObjectModel[] {
    var ids: string[];
    ids = model.webObjects;
    if (ids == undefined) return null;
    let objects = [];
    for (let i = 0; i < ids.length; i++) {
      objects.push(this.findByObjectId(ids[i]));
    }
    return objects;
  }
  public addWebObject(webpage_id, webobject) {
    webobject.webpageId = webpage_id.$oid ? webpage_id.$oid : webpage_id;
    if(webobject.xpaths && webobject.xpaths.length > 0) {
      webobject.xpaths.forEach((xpath, index) => {
        if (xpath && xpath.trim() !== "") {
          // Update the XPath by replacing \" with single quotes
          webobject.xpaths[index] = xpath.replace(/\"/g, "'");
        }
      });
    }
    if (webobject.css && webobject.css.trim() !== "") {
      webobject.css = webobject.css.replace(/\"/g, "'");
    }
    var data = {
      webPage: { _id: webpage_id.$oid ? webpage_id.$oid : webpage_id },
      webObject: webobject
    };
    return this.rest.put('addwebobject', data);
  }
  public updateObject(webpage_id, webobject) {
    webobject.webpageId = webobject.webpageId.$oid ? webobject.webpageId.$oid : webobject.webpageId;
    if(webobject.xpaths && webobject.xpaths.length > 0) {
      webobject.xpaths.forEach((xpath, index) => {
        if (xpath && xpath.trim() !== "") {
          // Update the XPath by replacing \" with single quotes
          webobject.xpaths[index] = xpath.replace(/\"/g, "'");
        }
      });
    }
    if (webobject.css && webobject.css.trim() !== "") {
      webobject.css = webobject.css.replace(/\"/g, "'");
    }
    if (webobject.selectedWebPageId && webobject.selectedWebPageId.$oid) {
      webobject.selectedWebPageId = webobject.selectedWebPageId.$oid;
    }
    var data = {
      webPage:  { _id: webpage_id.$oid ? webpage_id.$oid : webpage_id },
      webObject: webobject
    };
    return this.rest.post('updatewebobject', data);
  }


  public updateObjectdb2(webpage_id, webobject) {
    webobject.webpageId = webobject.webpageId.$oid ? webobject.webpageId.$oid : webobject.webpageId;
    if(webobject.xpaths && webobject.xpaths.length > 0) {
      webobject.xpaths.forEach((xpath, index) => {
        if (xpath && xpath.trim() !== "") {
          // Update the XPath by replacing \" with single quotes
          webobject.xpaths[index] = xpath.replace(/\"/g, "'");
        }
      });
    }
    if (webobject.css && webobject.css.trim() !== "") {
      webobject.css = webobject.css.replace(/\"/g, "'");
    }
    if (webobject.selectedWebPageId && webobject.selectedWebPageId.$oid) {
      webobject.selectedWebPageId = webobject.selectedWebPageId.$oid;
    }
    var data = {
      webPage: { _id: webpage_id.$oid ? webpage_id.$oid : webpage_id },
      webObject: webobject
    };
    return this.rest.post('updatewebobjectdb2', data);
  }
  public deleteObject(webobject_id) {
    var data = {
      webObject: { _id: webobject_id }
    };
    return this.rest.post('deletewebobject', data);
  }
}
